import Data from "../types/Data";

export default function getReceipts(data: Data) {
  return data.receiptIds.map((id) => data.Receipt[id]);
}
